import React from 'react';
import { MessageSquare, Users } from 'lucide-react';

export default function TeamCollaboration() {
  const team = [
    {
      id: '1',
      name: 'Sarah Johnson',
      role: 'Deal Lead',
      avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150',
      status: 'online'
    },
    {
      id: '2',
      name: 'Michael Chen',
      role: 'Financial Analyst',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150',
      status: 'offline'
    },
    {
      id: '3',
      name: 'Emily Rodriguez',
      role: 'Legal Counsel',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150',
      status: 'online'
    }
  ];

  return (
    <div className="h-full">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Team Collaboration</h2>
        <p className="mt-2 text-gray-600">Work together on deal execution</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <div className="bg-white rounded-lg shadow-sm">
            <div className="px-6 py-4 border-b border-gray-200">
              <h3 className="text-lg font-medium text-gray-900">Recent Activity</h3>
            </div>

            <div className="divide-y divide-gray-200">
              {[
                {
                  user: 'Sarah Johnson',
                  action: 'uploaded financial statements',
                  deal: 'Tech Corp Acquisition',
                  time: '2 hours ago'
                },
                {
                  user: 'Michael Chen',
                  action: 'completed valuation model',
                  deal: 'Manufacturing Merger',
                  time: '4 hours ago'
                },
                {
                  user: 'Emily Rodriguez',
                  action: 'reviewed contract documents',
                  deal: 'Retail Chain Sale',
                  time: '6 hours ago'
                }
              ].map((activity, index) => (
                <div key={index} className="px-6 py-4">
                  <div className="flex items-start">
                    <div className="flex-1">
                      <p className="text-sm text-gray-900">
                        <span className="font-medium">{activity.user}</span>
                        {' '}{activity.action} in{' '}
                        <span className="font-medium">{activity.deal}</span>
                      </p>
                      <p className="mt-1 text-sm text-gray-500">{activity.time}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div>
          <div className="bg-white rounded-lg shadow-sm">
            <div className="px-6 py-4 border-b border-gray-200">
              <h3 className="text-lg font-medium text-gray-900">Team Members</h3>
            </div>

            <div className="divide-y divide-gray-200">
              {team.map((member) => (
                <div key={member.id} className="px-6 py-4 flex items-center">
                  <img
                    src={member.avatar}
                    alt={member.name}
                    className="w-10 h-10 rounded-full"
                  />
                  <div className="ml-3 flex-1">
                    <p className="text-sm font-medium text-gray-900">{member.name}</p>
                    <p className="text-sm text-gray-500">{member.role}</p>
                  </div>
                  <div className="flex items-center">
                    <span
                      className={`inline-block w-2 h-2 rounded-full ${
                        member.status === 'online' ? 'bg-green-400' : 'bg-gray-300'
                      }`}
                    />
                    <MessageSquare className="w-5 h-5 text-gray-400 hover:text-gray-600 cursor-pointer ml-4" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}